import { initializeApp, getApps } from 'firebase/app'
import { getAnalytics, isSupported as analyticsSupported } from 'firebase/analytics'
import { getAuth } from 'firebase/auth'
import { getFirestore } from 'firebase/firestore'
import { getFunctions } from 'firebase/functions'
import { getStorage } from 'firebase/storage'

const firebaseConfig = {
  apiKey: "AIzaSyDQVzhKC2gqaL23tBQBJeqVg67uDp4YZZQ",
  authDomain: "seniorz-connect.firebaseapp.com",
  projectId: "seniorz-connect",
  storageBucket: "seniorz-connect.firebasestorage.app",
  messagingSenderId: "823244143172",
  appId: "1:823244143172:web:6a0486d560c04a344d5a11",
  measurementId: "G-H1VYHH2WHZ"
};

// Prevent re-init during HMR
const app = getApps().length ? getApps()[0] : initializeApp(firebaseConfig)

// Core services
const auth = getAuth(app)
const db = getFirestore(app)
const storage = getStorage(app)
const functions = getFunctions(app, 'us-central1')

// Analytics (browser-only, guards SSR/tests)
let analytics = null
if (typeof window !== 'undefined') {
  analyticsSupported().then((ok) => {
    if (ok) analytics = getAnalytics(app)
  })
}

export { app, auth, db, storage, functions, analytics }